import {areIntervalsOverlapping} from 'date-fns';

/**
 * Whether two periods of the same vehicle overlap in time and therefore need separate rows.
 *
 * Until T20-140155 any two events touching the same calendar day counted as colliding (added with
 * the original calendar in T20-84084), which stacked a morning and an afternoon rental into two
 * lanes even though they never overlap.
 */
export function eventsOverlap(
  eventA: {start: Date; end: Date},
  eventB: {start: Date; end: Date}
): boolean {
  return areIntervalsOverlapping(
    {start: eventA.start, end: eventA.end},
    {start: eventB.start, end: eventB.end}
  );
}
